//ARROW Down
import * as React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core"
import { forwardRef } from "react";


export const ChevronDown: React.FC<SvgIconProps> = forwardRef(({...props}, ref) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20" innerRef={ref}>
      <g>
        <rect width="20" height="20" fill="none"/>
        <path d="M3715.687,12027.661a1,1,0,0,1-.733-.291l-4.948-4.951a1,1,0,0,1,1.413-1.415l4.268,4.268,4.268-4.268a1,1,0,1,1,1.413,1.415l-4.95,4.951a1,1,0,0,1-.706.292Z" transform="translate(-3705.688 -12013.389)" fill="currentColor"/>
      </g>
    </SvgIcon>
  );
})

export default ChevronDown;